module.exports = __webpack_public_path__ + "static/media/icon-calender.ab7ac2d5.svg";